// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"443":"8ffb0212","453":"c1ee2f7b"}[chunkId] + ".chunk.js";
};